import React from 'react';
import { Helmet } from 'react-helmet';

const EnhancedSEO = ({ 
  pageConfig, 
  structuredData = [], 
  additionalMetaTags = [],
  children 
}) => {
  const {
    title,
    metaTags,
    canonicalUrl
  } = pageConfig;

  return (
    <Helmet>
      {/* Page Title */}
      <title>{title}</title>
      
      {/* Canonical URL */}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      
      {/* Meta Tags */}
      {metaTags.map((tag, index) => {
        if (tag.name) {
          return <meta key={index} name={tag.name} content={tag.content} />;
        } else if (tag.property) {
          return <meta key={index} property={tag.property} content={tag.content} />;
        }
        return null;
      })}
      
      {/* Additional Meta Tags */}
      {additionalMetaTags.map((tag, index) => {
        if (tag.name) {
          return <meta key={`additional-${index}`} name={tag.name} content={tag.content} />;
        } else if (tag.property) {
          return <meta key={`additional-${index}`} property={tag.property} content={tag.content} />;
        }
        return null;
      })}
      
      {/* Structured Data */}
      {structuredData.map((schema, index) => (
        <script 
          key={`schema-${index}`}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ 
            __html: typeof schema === 'string' ? schema : JSON.stringify(schema) 
          }}
        />
      ))}
      
      {/* Additional children (custom head elements) */}
      {children}
    </Helmet>
  );
};

export default EnhancedSEO;
